namespace GeniuzPOS.PosShift {
    export enum CancelFgstatus {
        Use = 0,
        cancle = 1
    }
    Serenity.Decorators.registerEnumType(CancelFgstatus, 'GeniuzPOS.PosShift.CancelFgstatus');
}
